module.exports = __webpack_public_path__ + "fonts/Graphik-LightItalic.3b963d0a.woff";